import currencySign from 'utils/intl/currencySign.util';
import C from 'utils/values/constant.util';
import fixed from 'utils/values/fixed.util';

import { convertToMoneyAfterVat } from 'reports/utils';

export const categoriesMap = (t) => ({
  NO_SHOW: t('businessReports.commissions.categoryTypes.noShow'),
  TOTAL_SERVICES: t('businessReports.commissions.categoryTypes.totalServices'),
  TOTAL: t('businessReports.commissions.categoryTypes.total'),
  RETAIL: t('businessReports.commissions.categoryTypes.retail'),
});

export const translatedCategories = (t) =>
  C({
    totalServicesName: t('businessReports.commissions.totalServicesName'),
    totalName: t('businessReports.commissions.totalName'),
  });

export const translatedHeaders = (t) =>
  C({
    categories: t('businessReports.commissions.categories'),
    revenueExclTips: t('businessReports.commissions.revenueExclTips'),
    staffCommission: t('businessReports.commissions.staffCommission'),
    staffRevenue: t('businessReports.commissions.staffRevenue'),
    businessRevenue: t('businessReports.commissions.businessRevenue'),
  });

export const getCommissionId = (commissionRatesOne, object_id) => {
  if (commissionRatesOne) {
    for (let i = 0; i < commissionRatesOne.length; i += 1) {
      if (commissionRatesOne[i].object_type === 'category' && commissionRatesOne[i].object_id === object_id) {
        return commissionRatesOne[i].id;
      }
    }
  }
  return -1;
};

export const getCommissionRate = (oneCommissionRates, object_id) => {
  if (oneCommissionRates) {
    const comArr = oneCommissionRates.filter((c) => c.object_type === 'category' && c.object_id === object_id);
    return comArr.length ? comArr[0].percentage : 0;
  }
  return 0;
};

export const transformCommissionRate = (rate) => (rate !== '-' ? `${fixed(Number(rate) * 100)}%` : '-');

export const makeCommissionObj = (categories, products, commissionArray, revenue_from_no_shows, revenue_from_products, stylistId, stylistName, t) => {
  const safeRevenueFromNoShows = revenue_from_no_shows || 0;
  const safeRevenueFromProducts = revenue_from_products || 0;
  const CATEGORY_TYPES = categoriesMap(t);
  const categoryArr = Object.values(categories);
  const commissionObj = {};
  let totalServiceRevenue = 0;
  let totalServiceCommission = 0;
  let allCommissionRates = [];

  if (commissionArray && commissionArray.length > 0) {
    allCommissionRates = commissionArray[1];
  }

  if (categoryArr.length > 0) {
    for (let i = 0; i < categoryArr.length; i += 1) {
      const object_id = categoryArr[i].id;
      const commissionRate = getCommissionRate(allCommissionRates, object_id);
      const ItemRevenue = categoryArr[i].price;
      const businessShare = ItemRevenue * (1 - commissionRate);

      totalServiceRevenue += ItemRevenue;
      const commission = ItemRevenue * commissionRate;
      totalServiceCommission += commission;
      commissionObj[categoryArr[i].name] = {
        stylistId,
        object_id,
        id: getCommissionId(allCommissionRates, object_id),
        ItemRevenue,
        commissionRate,
        commission,
        businessShare,
        object_type: 'category',
      };
    }
  }

  if (Object.values(commissionObj).length) {
    commissionObj[CATEGORY_TYPES.TOTAL_SERVICES] = {
      ItemRevenue: totalServiceRevenue,
      commissionRate: '-',
      commission: totalServiceCommission,
      businessShare: totalServiceRevenue - totalServiceCommission,
    };
  }

  const priceList = Object.values(products).map((p) => p.price);
  const totalRetail = priceList.length ? priceList.reduce((a, total) => total + a) : 0;
  let retailCommission = 0;
  let noshowCommission = 0;

  if (commissionArray && commissionArray[1] && commissionArray.length && commissionArray[1].length) {
    for (let i = 0; i < allCommissionRates.length; i += 1) {
      if (allCommissionRates[i].object_type === 'all_products') {
        const cRate = allCommissionRates[i].percentage ? allCommissionRates[i].percentage : 0;
        retailCommission = totalRetail * cRate;
        commissionObj[CATEGORY_TYPES.RETAIL] = {
          object_id: allCommissionRates[i].id,
          id: allCommissionRates[i].id ? allCommissionRates[i].id : -1,
          stylistId,
          object_type: allCommissionRates[i].object_type,
          ItemRevenue: safeRevenueFromProducts,
          commissionRate: allCommissionRates[i].percentage,
          commission: retailCommission,
          businessShare: safeRevenueFromProducts - retailCommission,
        };
      } else if (allCommissionRates[i].object_type === 'no_show') {
        const cRate = allCommissionRates[i].percentage ? allCommissionRates[i].percentage : 0;
        noshowCommission = safeRevenueFromNoShows * cRate;
        commissionObj[CATEGORY_TYPES.NO_SHOW] = {
          object_id: allCommissionRates[i].id,
          id: allCommissionRates[i].id ? allCommissionRates[i].id : -1,
          stylistId,
          object_type: allCommissionRates[i].object_type,
          ItemRevenue: safeRevenueFromNoShows,
          commissionRate: allCommissionRates[i].percentage,
          commission: noshowCommission,
          businessShare: safeRevenueFromNoShows - noshowCommission,
        };
      }
    }
  }

  if (!commissionObj[CATEGORY_TYPES.RETAIL]) {
    commissionObj[CATEGORY_TYPES.RETAIL] = {
      object_id: 0,
      id: -1,
      stylistId,
      object_type: 'all_products',
      ItemRevenue: safeRevenueFromProducts,
      commissionRate: 0,
      commission: 0,
      businessShare: safeRevenueFromProducts,
    };
  }

  if (!commissionObj[CATEGORY_TYPES.NO_SHOW]) {
    commissionObj[CATEGORY_TYPES.NO_SHOW] = {
      object_id: 0,
      id: -1,
      stylistId,
      object_type: 'no_show',
      ItemRevenue: safeRevenueFromNoShows,
      commissionRate: 0,
      commission: 0,
      businessShare: safeRevenueFromNoShows,
    };
  }

  const totalRevenue = totalServiceRevenue + safeRevenueFromProducts + safeRevenueFromNoShows;
  const totalCommission = totalServiceCommission + retailCommission + noshowCommission;

  const totalBusinessShare = Object.values(commissionObj)
    .filter((item) => !!item.object_type)
    .reduce((sum, item) => {
      const rounded = Math.round(item.businessShare * 100) / 100;
      return sum + rounded;
    }, 0);

  commissionObj[CATEGORY_TYPES.TOTAL] = {
    ItemRevenue: totalRevenue,
    commissionRate: '-',
    commission: totalCommission,
    businessShare: totalBusinessShare,
  };

  return commissionObj;
};

export const createCsvForStylist = (data, t, currency) => {
  const TABLE_HEADERS = translatedHeaders(t);
  const dataArray = Array.isArray(data) ? data : Object.keys(data).map((k) => ({ [k]: data[k] }));
  const convertValue = (value) => currencySign({ value: convertToMoneyAfterVat(value), currentSalonAbbr: currency });

  return dataArray.reduce((acc, categoryGroup) => {
    const rows = Object.keys(categoryGroup).map((category) => {
      const item = categoryGroup[category];
      return {
        [TABLE_HEADERS.categories]: category,
        [TABLE_HEADERS.revenueExclTips]: convertValue(item.ItemRevenue),
        [TABLE_HEADERS.staffCommission]: transformCommissionRate(item.commissionRate),
        [TABLE_HEADERS.staffRevenue]: convertValue(item.commission),
        [TABLE_HEADERS.businessRevenue]: convertValue(item.businessShare),
      };
    });
    return acc.concat(rows);
  }, []);
};

export const createAllCsvData = (stylists, allCommissionReport, t, currency) => {
  const commissionEntries = allCommissionReport && Object.keys(allCommissionReport).length ? Object.entries(allCommissionReport) : [];
  const TABLE_HEADERS = translatedHeaders(t);
  const SEP = ',';

  const columns = [TABLE_HEADERS.categories, TABLE_HEADERS.revenueExclTips, TABLE_HEADERS.staffCommission, TABLE_HEADERS.staffRevenue, TABLE_HEADERS.businessRevenue];

  const esc = (val) => {
    const s = String(val ?? '');
    return s.includes(SEP) || s.includes('"') ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const emptyRow = Array(columns.length).fill('').join(SEP);
  const headerRow = columns.map(esc).join(SEP);

  const sections = stylists.map((rev, i) => {
    const oneCommission = commissionEntries.find((c) => c[0] === rev.name);
    const commissionObj = makeCommissionObj(rev.categories, rev.products, oneCommission, rev.revenue_from_no_shows, rev.revenue_from_products, rev.id, rev.name, t);

    const csvRows = createCsvForStylist(commissionObj, t, currency);
    const nameRow = [esc(rev.name), ...Array(columns.length - 1).fill('')].join(SEP);
    const dataRows = csvRows.map((row) => columns.map((col) => esc(row[col])).join(SEP)).join('\r\n');

    const parts = [nameRow, headerRow, dataRows];
    if (i < stylists.length - 1) parts.push(emptyRow);
    return parts.join('\r\n');
  });

  return sections.join('\r\n');
};
